import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.04554 1.51115C7.30992 0.610651 8.57831 0.590843 8.87069 1.48263L10.2247 5.61255L14.3925 5.65498C15.2935 5.66415 15.6824 6.80072 14.976 7.35996L11.6352 10.0047L12.9036 14.1641C13.1733 15.0485 12.1549 15.7623 11.4155 15.207L8.02444 12.6605L4.94426 14.9398C4.21558 15.479 3.21573 14.7956 3.45353 13.9208L4.536 9.93896L1.08386 7.3257C0.353291 6.77266 0.744405 5.608 1.66069 5.608L5.84274 5.608L7.04554 1.51115ZM7.98068 2.94081L7.01749 6.22151C6.89801 6.62847 6.52462 6.908 6.10049 6.908L2.68594 6.908L5.50608 9.04284C5.8171 9.27828 5.95382 9.67912 5.85149 10.0555L4.96816 13.3048L7.45746 11.4628C7.79725 11.2113 8.26185 11.213 8.59985 11.4668L11.3523 13.5338L10.3233 10.1592C10.2086 9.78316 10.3359 9.37521 10.6442 9.13116L13.4057 6.945L9.9647 6.90997C9.5552 6.9058 9.19387 6.64119 9.06629 6.25205L7.98068 2.94081Z"
      className="iconBorder"
    />
    <path
      d="M7.01749 6.22151L7.98068 2.94081L9.06629 6.25205C9.19387 6.64119 9.5552 6.9058 9.9647 6.90997L13.4057 6.945L10.6442 9.13116C10.3359 9.37521 10.2086 9.78316 10.3233 10.1592L11.3523 13.5338L8.59985 11.4668C8.26185 11.213 7.79725 11.2113 7.45746 11.4628L4.96816 13.3048L5.85149 10.0555C5.95382 9.67912 5.8171 9.27828 5.50608 9.04284L2.68594 6.908L6.10049 6.908C6.52462 6.908 6.89801 6.62847 7.01749 6.22151Z"
      className="iconFill"
    />
  </svg>
);

const StarFilledIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default StarFilledIcon;
